import React from "react";

class MatchEdit extends React.Component {
  state = {};
  render() {
    return <h1>Edit Match</h1>;
  }
}

export default MatchEdit;
